<template>
  <div class="rounded-lg overflow-hidden border border-gray-300">
    <table class="divide-y divide-gray-300">
      <thead class="bg-white dark:bg-transparent">
        <tr class="text-sm">
          <th
            v-for="(columnHeading, index) in splitHeadings"
            :key="index"
            class="px-4 py-3 text-left font-semibold border-[#dbdbdb] border-2"
          >
            {{ columnHeading }}
          </th>
        </tr>
      </thead>
      <tbody class="text-sm divide-y divide-gray-200">
        <tr
          v-for="(item, index) in data"
          :key="index"
          :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
          class="hover:bg-gray-100 dark:bg-transparent dark:hover:bg-[rgba(98,69,116,0.5)]"
        >
          <td class="px-4 py-4 align-top border-[#dbdbdb] border-2">
            {{ item.single }}
          </td>
          <td class="px-4 py-4 align-top border-[#dbdbdb] border-2">
            {{ item.multi }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
const props = defineProps({
  heading: String,
  data: {
    type: Array,
    required: true,
  },
});
const splitHeadings = computed(() => {
  if (props.heading?.includes(" VS ")) {
    return props?.heading.split(" VS ");
  }
  return ["Column 1", "Column2"];
});
</script>
